import { useGame } from '../state/store'
import { LETTERS } from '../config/letters'
import { RARITY, UI } from '../config/colors'

export function AlphabetPanel() {
  const letters = useGame((s) => s.letters)
  const letterMap = new Map(letters.map((l) => [l.id, l]))

  return (
    <div className="rounded-lg border border-ink-border bg-ink-panel p-4">
      <div className="mb-3 font-bold text-ink-teal">ALPHABET</div>
      <div className="grid grid-cols-7 gap-1.5">
        {LETTERS.map((def) => {
          const state = letterMap.get(def.id)
          const owned = state != null && state.level > 0
          const isCapital = state?.capital ?? false

          return (
            <div
              key={def.id}
              className="flex flex-col items-center gap-0.5 rounded border p-1 text-center"
              style={{
                borderColor: owned ? RARITY[def.rarity] : UI.cellBorder,
                backgroundColor: owned ? UI.cellOwnedBg : 'transparent',
              }}
            >
              <span
                className="text-sm font-bold"
                style={{ color: owned ? RARITY[def.rarity] : UI.cellMuted }}
              >
                [{isCapital ? def.letter : (owned ? def.letter : def.letter.toLowerCase())}]
              </span>
              {owned && (
                <span className="text-[8px] tabular-nums text-ink-muted">
                  {def.heat > 0 ? (
                    <span className="text-teal-400">+{def.heat}</span>
                  ) : def.heat !== 0 ? (
                    <span className="text-sky-400">{def.heat}</span>
                  ) : ''}
                  {def.weight !== 0 ? (
                    <span className={def.weight > 0 ? 'text-amber-400' : 'text-ink-muted'}>
                      {' '}{def.weight > 0 ? `+${def.weight}` : def.weight}
                    </span>
                  ) : ''}
                </span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
